import React from 'react'
import Login from '../../componet/login/Login'

function LoginPage() {
  return (
    <div>
        <Login/>
    </div>
  )
}

export default LoginPage